import { GET_ORGANIZATION_RECEIPTS } from "./../graphql/queries/getOrganizationReceipts"
import { REMOVE_BOOKMARK_RECEIPT } from "./../graphql/mutations/removeBookmarkReceipt"
import { useMutation } from "@apollo/client"
import { GET_USER_RECEIPTS } from "../graphql/queries/getUserReceipts"

export const useRemoveBookmarkReceipt = ({ onCompleted, onError }) => {
  const [removeBookmarkReceipt, { client, data, loading }] = useMutation(REMOVE_BOOKMARK_RECEIPT, {
    onCompleted: onCompleted,
    onError: onError,
    refetchQueries: [GET_ORGANIZATION_RECEIPTS, GET_USER_RECEIPTS],
  })

  return { removeBookmarkReceipt, data, loading, client }
}
